import React from "react";
import styled from "styled-components";
import { breakpoints } from "../../utils/breakpoints";

const StyledDiv = styled.div`
	display: grid;
	position: relative;
	align-items: center;
	justify-content: space-between;
	text-align: center;
	padding: 70px 0;
	background: #1f232a no-repeat padding-box;
	border-radius: 20px;


	

	.image-section {
		width: 25vw;
		height: 25vw;
		margin: auto;
		position: absolute;
		top: -35%;
		left: 50%;
		
	
		transform: translateX(-50%);
		border-radius: 8px;


		img {
			width: 75%;
		}
	}

	.txt-section {

		background: #1f232a no-repeat padding-box;
		width: 85%;
		text-align: center;
		margin: auto;
		margin-top: 100px;

		.name {
			font: normal normal bold 48px/80px Nexa-bold;
			background: linear-gradient(180deg, #89D0C2 0%, #44B2DD 100%);
					font-family: "nexa-bold";
					background-clip: text;
					font-weight: 900;
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
		}

		.title {
			font: normal normal bold 24px/80px Nexa-bold;
			background: linear-gradient(180deg, #89D0C2 0%, #44B2DD 100%);
					font-family: "nexa-bold";
					background-clip: text;
					font-weight: 900;
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
					
		}

		.desc {
			font: normal normal normal 24px/40px Nexa-light;
		}
	}

	@media screen and ${breakpoints.device.laptopL} {
		padding: 20px 0;

		.image-section {
			img {
				width: 85%;
			}
		
		}

		
	}

	@media screen and ${breakpoints.device.laptop} {
		padding: 20px 0;

		.image-section {
			top: -25%;
			left: 50%;
			img {
				width: 90%;
			}
		
		}

		
	}


	@media screen and ${breakpoints.device.tablet} {
		padding: 20px 0;

		.image-section {
			top: -15%;
			left: 50%;
			img {
				width: 100%;
			}
		
		}

		
	}

	@media screen and ${breakpoints.device.mobileL} {
		flex-direction: column;
		padding: 20px 0;

		.image-section {
			width: 40%;
			height: 50vw;
			top: -17%;
			margin-bottom: 20px;
		}

		.txt-section {
			width: 100%;
			margin-left: 0px;

			.name,
			.title,
			.desc {
				font-size: 25px;
				text-align: center;
			}

			.name {
				font: normal normal bold 28px/50px Nexa-bold;
			}

			.title {
				font: normal normal bold 22px/40px Nexa-light;
			}

			.desc {
				font: normal normal normal 20px/30px Nexa-light;
				font-size: 15px;
			}
		}
	}
`;

const PersonCard = ({ data, side }) => {
	// 0 - left
	// 1 - right
	return (
		<StyledDiv>
			<div>
				<div className="image-section">
					<img src={data.image} alt="" />
				</div>
			</div>
			<div className="txt-section">
				<div className="name">{data.name}</div>
				<div className="title">{data.title}</div>
				<div className="desc">{data.desc}</div>
			</div>
		</StyledDiv>
	);
};

export default PersonCard;
